import { useState } from 'react'
import { Typography, Box, Button } from '@mui/material'
import { Grid } from '../../UniversalComponents'
import { addUser } from '../../../apiRoutes/userRoutes'

const VerifyEmail = () => {
    const getEmailId = window.location.pathname.slice(
        13,
        window.location.pathname.length
    )
    const [verified, setVerified] = useState(false)

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3,
                width: { sm: `100%` },

                backgroundColor: 'primary',
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ marginTop: 10 }}>
                    {!verified ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (getEmailId) {
                                    addUser({ _id: getEmailId })
                                    setVerified(true)
                                }
                            }}
                            sx={{
                                width: '100%',
                                height: 55,
                            }}
                        >
                            Press to Verify Account Creation
                        </Button>
                    ) : (
                        <Typography
                            variant="h3"
                            color={'primary'}
                            align="center"
                            sx={{ margin: 2 }}
                        >
                            Your email has been verified. You can now login to
                            the app.
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default VerifyEmail
